export default __webpack_public_path__ + "static/media/bear.3bb764cd.svg";